import{GraphQLClient as e}from"graphql-request";const r=r=>{const{endpoint:t,config:n}=r;return new e(t,n)};export{r as createGraphQLClient};
